// extracted by mini-css-extract-plugin
export var messageSideLeft = "_se-1";
export var stateContainer = "_se-0";